import React from 'react'
import { Trash2, Edit } from 'react-feather'
import { Badge } from 'reactstrap'
import Avatar from '@components/avatar'

const maskText = (text) => {
  if (!text || text.length <= 2) return text
  const firstTwo = text.substring(0, 2)
  const stars = '*'.repeat(text.length - 2)
  return firstTwo + stars
}

export const columns = (handleEdit, handleDelete) => [
  {
    name: 'İŞKUR Kodu',
    sortable: true,
    minWidth: '150px',
    sortField: 'iskurCode',
    selector: row => row.iskurCode,
    cell: row => row.iskurCode
  },
  {
    name: 'Şifre',
    sortable: false,
    minWidth: '120px',
    sortField: 'password',
    selector: row => row.password,
    cell: row => maskText(row.password)
  },
  {
    name: 'Durum',
    sortable: true,
    minWidth: '120px',
    sortField: 'isActive',
    selector: row => row.isActive,
    cell: row => (
      <Badge color={row.isActive ? 'light-success' : 'light-secondary'} pill>
        {row.isActive ? 'Aktif' : 'Pasif'}
      </Badge>
    )
  },
  {
    name: 'Oluşturma Tarihi',
    sortable: true,
    minWidth: '180px',
    sortField: 'createdDate',
    selector: row => row.createdDate,
    cell: row => row.createdDate
  },
  {
    name: 'İşlemler',
    minWidth: '150px',
    cell: row => (
      <div className='column-action d-flex align-items-center'>
        <Edit size={18} className='cursor-pointer me-1' onClick={() => handleEdit(row)} />
        <Trash2 size={18} className='cursor-pointer' onClick={() => handleDelete(row.id)} />
      </div>
    )
  }
]